import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProductsPage } from '~/features/catalog-operations/pages/products-page';
import type { ProductTab } from '~/features/catalog-operations/types/catalog-operations.types';
import { RequireChannelConnection } from '~/features/onboarding/components/require-channel-connection';

const searchSchema = z.object({
  tab: z.enum(['newly-enriched', 'needs-attention']).catch('newly-enriched'),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/catalog-operations/$batchId_/products',
)({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const { batchId } = Route.useParams();
  const { tab } = Route.useSearch();
  return (
    <RequireChannelConnection>
      <ProductsPage batchId={batchId} initialTab={tab as ProductTab} />
    </RequireChannelConnection>
  );
}
